import React from 'react';
import { Link } from 'gatsby';

const Category = (props) => {
  return (
    <div className={props.divClass}>
        <ul className={props.listClass}>
          <li>
            <Link to='/projects/#civil' 
            onClick= {props.onClose}>
              civil/architecture
            </Link>
          </li>
          <li>
            <Link to='/projects/#mining- heavy industory'
            onClick= {props.onClose}>
              mining/heavy industry
            </Link>
          </li>
          <li>
            <Link to='/projects/#automotive'
            onClick= {props.onClose}>
              automotive
            </Link>
          </li>
          <li>
            <Link to='/projects/#water'
            onClick= {props.onClose}>
              water
            </Link>
          </li>
          <li>
            <Link to='/projects/#energy'
            onClick= {props.onClose}>
              energy
            </Link>
          </li>
          <li>
            <Link to='/projects/#robotics'
            onClick= {props.onClose}>
              robotics/automation
            </Link>
          </li>
          <li>
            <Link to='/projects/#telecommunication'
            onClick= {props.onClose}>
              tele communication
            </Link>
          </li>
        </ul>
      </div>
  );
};

export default Category;